import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoModal } from 'ui';
import ChannelSelect from 'components/ChannelSelect';
import { connect } from 'react-redux';

import './index.scss';

class PracticeModal extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      target: null,
      channel: null,
      open: false,
    };
    sessionStorage.clear();
  }

  componentDidMount() {
    this.setState({ open: true }, this.onFrameLoad.bind(this));
  }

  onFrameLoad() {
    this.setState({ frame: this.frame }, () => {
      const { frame } = this.state;
      // Remove the default body margin
      frame.contentDocument.body.style.margin = 0;
      // Add a getter for navigator so we can pretend we're on mobile(full screen mode)
      frame.contentWindow.window.navigator.__defineGetter__(
        'userAgent',
        () => 'iphone'
      );
      // Add the Widget settings
      frame.contentWindow.window.GeckoChatSettings = {
        account_id: `${this.props.region}_${this.props.accountId}_${this.props.botId}_practice`,
        api_override: this.props.apiUrl,
        practice_mode: true,
        user_info: {
          bot: { id: this.props.botId },
        },
      };

      // Firefox can't append to iFrame witout a timeout
      // @see https://bugzilla.mozilla.org/show_bug.cgi?id=297685
      setTimeout(() => {
        // Load the widget script into the iframe
        const script = frame.contentDocument.createElement('script');
        script.src = process.env.REACT_APP_WIDGET_CODE;
        // IE needs .appendChild instead of .append()
        frame.contentDocument.body.appendChild(script);
      }, 100);

      // Wait for the script to set itself up then open the Widget
      const tryOpenWidget = () => {
        if (
          frame.contentWindow &&
          frame.contentWindow.window.GeckoChat &&
          frame.contentWindow.window.GeckoChat.open
        ) {
          frame.contentWindow.window.GeckoChat.open();
          const tryHideHeader = () => {
            if (frame.contentDocument.body.querySelector('.Gecko-header')) {
              frame.contentDocument.body.querySelector(
                '.Gecko-header'
              ).style.display = 'none';
              frame.contentDocument.body.querySelector(
                '.TagLine'
              ).style.display = 'none';
            } else {
              setTimeout(tryHideHeader, 100);
            }
          };
          tryHideHeader();

          // IE cant display the chat widget with an absolute position
          // Every other browser doesnt seem to care
          const tryFixPositioning = () => {
            if (frame.contentDocument.body.querySelector('.GeckoChatWidget')) {
              frame.contentDocument.body.querySelector(
                '.GeckoChatWidget'
              ).style.position = 'static';
              frame.contentDocument.body.querySelector(
                '.GeckoChatWidget .ChatContainer.mobile'
              ).style.overflow = 'hidden';
            } else {
              setTimeout(tryFixPositioning, 100);
            }
          };
          tryFixPositioning();
        } else {
          setTimeout(tryOpenWidget, 100);
        }
      };
      tryOpenWidget();
    });
  }

  render() {
    return (
      <div className="PracticeModal">
        <GeckoModal name="Practice">
          {this.state.open ? (
            <iframe src="" ref={(elem) => (this.frame = elem)} />
          ) : null}
        </GeckoModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const regionMap = {
    'http://localhost:38057': 'local',
    'https://api-euwest2.geckochat.io': 'eu-west-2',
    'https://api-useast1.geckochat.io': 'us-east-1',
    'https://api-eustage.geckochat.io': 'eu-west-2',
  };
  return {
    channels: state.channels,
    apiUrl: state.appState.apiUrl,
    accountId: state.appState.loggedInUser.account_id,
    region: regionMap[state.appState.apiUrl],
  };
};

export default connect(mapStateToProps)(PracticeModal);
